import { render, staticRenderFns } from "./SectionPartnersFeedback.vue?vue&type=template&id=62df4d70&"
import script from "./SectionPartnersFeedback.vue?vue&type=script&lang=js&"
export * from "./SectionPartnersFeedback.vue?vue&type=script&lang=js&"
import style0 from "./SectionPartnersFeedback.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports